App.Views.RouteSummary = {

    clearGridContainer: function () {
        const gridSelector = "#RouteSummary #contentContainer";
        const gridContainer = document.querySelector(gridSelector);
        if (gridContainer) {
            gridContainer.innerHTML = '';
        }
    },

    adjustGridHeight: function () {
        const header = document.querySelector('#RouteSummary .gridActions.ui-widget-header');
        const grid = document.querySelector('#RouteSummary #grid.display.ui-widget');
        if(header && grid){
            grid.style.top = header.offsetTop + header.offsetHeight + 'px'
        }
    },

    renderOptions: function (indexSelected) {

        var divParent,
            optionRoutes, optionStop, optionOrdersAndLineItems, spanFilterByTitle,
            labelOptionRoutes, labelOptionStops, labelOptionsOrdersAndLineItems,
            divOptionRoutes, divOptionStops, divOptionsOrdersAndLineItems,
            resource = Monet.I18n;

        divParent = document.createElement('div');
        divParent.id = 'routeMonitorOptions';

        divOptionRoutes = document.createElement('div');
        divOptionStops = document.createElement('div');
        divOptionsOrdersAndLineItems = document.createElement('div');

        spanFilterByTitle = document.createElement('span');
        labelOptionRoutes = document.createElement('label');
        labelOptionStops = document.createElement('label');
        labelOptionsOrdersAndLineItems = document.createElement('label');

        labelOptionRoutes.innerHTML = resource.getResourcesByKey('Greenmile.RouteMonitor.labelOptionRoute');
        labelOptionRoutes.setAttribute('for', 'optionRouteGrid');
        spanFilterByTitle.innerHTML = `${resource.getResourcesByKey('Greenmile.PanelBuilder.FilterEditor')}:`;

        labelOptionStops.innerHTML = resource.getResourcesByKey('Greenmile.RouteMonitor.labelOptionStop');
        labelOptionStops.setAttribute('for', 'optionStopGrid');
        spanFilterByTitle.setAttribute('id', 'label-filterBy')

        labelOptionsOrdersAndLineItems.innerHTML = resource.getResourcesByKey('Greenmile.RouteMonitor.labelOptionOrderAndLineItems');
        labelOptionsOrdersAndLineItems.setAttribute('for', 'optionOrderAndLineItemsGrid');


        optionRoutes = document.createElement('input');
        optionStop = document.createElement('input');
        optionOrdersAndLineItems = document.createElement('input');

        optionRoutes.type = 'radio';
        optionRoutes.name = 'gridSelector';
        optionRoutes.id = 'optionRouteGrid';

        optionStop.type = 'radio';
        optionStop.name = 'gridSelector';
        optionStop.id = 'optionStopGrid';

        optionOrdersAndLineItems.type = 'radio';
        optionOrdersAndLineItems.name = 'gridSelector';
        optionOrdersAndLineItems.id = 'optionOrderAndLineItemsGrid';

        if (indexSelected === 1) {

            optionRoutes.setAttribute('checked', 'checked');

        } else if (indexSelected === 2) {

            optionStop.setAttribute('checked', 'checked');

        } else if (indexSelected === 3) {

            optionOrdersAndLineItems.setAttribute('checked', 'checked');

        }

        optionRoutes.addEventListener('click', function () {
            Monet.Grid.Utils.clearPagination('RouteSummaryRoutes');
            window.location.href = '#/RouteSummary';

        });

        optionStop.addEventListener('click', function () {

            Monet.Grid.Utils.clearPagination('RouteSummaryStops');
            window.location.href = '#/RouteSummary/Stops';

        });

        optionOrdersAndLineItems.addEventListener('click', function () {

            Monet.Grid.Utils.clearPagination('RouteSummaryOrders');
            Monet.Grid.Utils.clearPagination('RouteSummaryLineItems');
            window.location.href = '#/RouteSummary/OrderAndLineItems';

        });

        divOptionRoutes.appendChild(optionRoutes);
        divOptionRoutes.appendChild(labelOptionRoutes);

        divOptionStops.appendChild(optionStop);
        divOptionStops.appendChild(labelOptionStops);

        divOptionsOrdersAndLineItems.appendChild(optionOrdersAndLineItems);
        divOptionsOrdersAndLineItems.appendChild(labelOptionsOrdersAndLineItems);

        divParent.appendChild(spanFilterByTitle);
        divParent.appendChild(divOptionRoutes);
        divParent.appendChild(divOptionStops);
        divParent.appendChild(divOptionsOrdersAndLineItems);

        return divParent;

    },

    prepareContainerToManyGrids: function (gridContainerId) {

        var container = document.querySelector("#RouteSummary #allContent #contentContainer");
        var indexGridSelected = 0;

        if (container && !container.querySelector("#" + gridContainerId)) {

            var fragment = document.createDocumentFragment(),
                div = document.createElement('div'),
                divActions = document.createElement('div'),
                divContainer = document.createElement('div');

            divActions.className = 'gridActions ui-widget-header';

            divContainer.id = 'grid';
            divContainer.className = 'display';

            if (gridContainerId !== 'lineItemsGrid') {

                if (gridContainerId === 'routeGrid') {
                    indexGridSelected = 1;
                } else if (gridContainerId === 'stopsGrid') {
                    indexGridSelected = 2;
                } else if (gridContainerId === 'ordersGrid') {
                    indexGridSelected = 3;
                }

                container.appendChild(this.renderOptions(indexGridSelected));

            }

            fragment.appendChild(divActions);
            fragment.appendChild(divContainer);

            div.id = gridContainerId;
            div.appendChild(fragment);

            container.appendChild(div);
        }

    },

    renderContentContainer: function () {

        var error = null,
            divContent = null;

        try {

            divContent = document.createElement('div');

            divContent.id = 'contentContainer';
            divContent.className = 'grid_list_template';

            return divContent;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on generate initial content.');
            error.console();

        }

    },

    showGridLineItems: function () {

        var lineItems = new Greenmile.RouteSummary.LineItems.Grid();
        var dataMapper = new Monet.Builder.DataMapper();
        var that = this;

        var callback = function () {

            var radioOrderAndLineItem = document.querySelector('#RouteSummary #optionOrderAndLineItemsGrid');

            if (radioOrderAndLineItem.checked) {
                dataMapper.copyDataMapperToAnotherNamespace('RouteSummaryLineItems');
                that.prepareContainerToManyGrids('lineItemsGrid');
                that.addResizableToItemsGrid();
                lineItems.show();
            }

        };

        dataMapper.setEntity('LineItem');
        dataMapper.build(callback);

    },

    showGridOrders: function () {

        var orders = new Greenmile.RouteSummary.Orders.Grid();
        var dataMapper = new Monet.Builder.DataMapper();
        var that = this;
        var stopID;

        if (App.Forms.RouteSummaryOrders.stop) {
            stopID = App.Forms.RouteSummaryOrders.stop.id;
        }

        var callback = function () {

            dataMapper.copyDataMapperToAnotherNamespace('RouteSummaryOrders');

            that.clearGridContainer();
            that.prepareContainerToManyGrids('ordersGrid');

            orders.show();
            that.showGridLineItems();

        };

        dataMapper.setEntity('Order');
        dataMapper.build(callback);

    },

    showOrdersAndLineItems: function () {
        Monet.Grid.Utils.clearPagination('RouteSummaryOrders');
        Monet.Grid.Utils.clearPagination('RouteSummaryLineItems');
        this.showGridOrders();
    },

    showGridStop: function () {

        var dataMapper = new Monet.Builder.DataMapper();

        Monet.Grid.Utils.clearPagination('RouteSummaryStops');

        var callback = () => {

            dataMapper.copyDataMapperToAnotherNamespace('RouteSummaryStops');

            this.clearGridContainer();
            this.prepareContainerToManyGrids('stopsGrid');
            new Greenmile.RouteSummary.Stops.Grid().show();
        };

        dataMapper.setEntity('StopView');
        dataMapper.build(callback);


    },

    showGridRoutes: function () {
        var route = new Greenmile.RouteSummary.Route.Grid();
        var dataMapper = new Monet.Builder.DataMapper();
        var that = this;
        Monet.Grid.Utils.clearPagination('RouteSummaryRoutes');
        var showGrid = function () {
            that.clearGridContainer();
            that.prepareContainerToManyGrids('routeGrid');
            route.show();
        };
        if (App.Forms.RouteSummaryRoutes) {
            if (App.Forms.RouteSummaryRoutes.dataMapper) {
                showGrid();
            } else {
                var callback = function () {
                    dataMapper.copyDataMapperToAnotherNamespace('RouteSummaryRoutes');
                    showGrid();
                };
                if (App.Forms.Route) {
                    App.Forms.Route.dataMapper = null;
                }
                dataMapper.setEntity('RouteView');
                dataMapper.build(callback);
            }
        }

    },

    sidebarTransition: function (entity) {
        Greenmile.RouteSummary.SideBar.clearStockSummaryInterval();

        var namespace = App.Forms[entity];
        var filter = namespace.filterBuilder;
        var grid = namespace.table;

        setTimeout(() => {
            filter.adjustHeaderSize();
            grid.resizeCanvas();
        }, 500);
    },

    showSignaturePopup: function (routeId, stopKey) {
        const signature = new Greenmile.Gallery.Signature(routeId, stopKey);
        const obj = {
            "selector": "#RouteSummary",
            "scopeBlock": "#allContent",
            "width": 900,
            "height": 520
        };
        signature.show(obj);
    },

    renderGridAndShowSignature: () => {
        const { routeId, stopKey } = App.Forms.RouteSummaryStops.filterFromReports;
        App.Views.RouteSummary.requestStopFilters(routeId, stopKey);
        App.Views.RouteSummary.showGridStop();
        App.Views.RouteSummary.showSignaturePopup(routeId, stopKey);
    },
    requestStopFilters: function (routeId, stopKey) {
        const ajax = new Monet.Ajax();
        ajax.url = 'StopView/restrictions?criteria={"filters":[' +
            '"route.key","route.date","route.organization.id","route.organization.description"' +
            '],"firstResult":0,"maxResults":51}';

        ajax.method = 'POST';

        ajax.data = '{"criteriaChain":[{"and":[' +
            '{"matchMode":"EXACT","attr":"stop.key","eq":"' + stopKey + '"},' +
            '{"attr":"route.id","eq":' + routeId + '}' +
            ']}]}';

        ajax.success = function (responseText) {

            if (responseText !== '') {
                const content = JSON.parse(responseText)[0];

                const model = new App.Models.Stop();
                model.set({
                    key: stopKey,
                    route: {
                        id: routeId,
                        key: content && content.route.key,
                        date: content && content.route.date,
                        organization: {
                            id: content && content.route.organization.id,
                            description: content && content.route.organization.description
                        }
                    }
                });
                App.Forms.RouteSummaryStops.signatureStop = model;
            }
            App.Views.RouteSummary.showGridStop();
        }

        ajax.error = () => {
            $.toast({
                message: Monet.I18n.getResourcesByKey("Stop.Signature.FilterError"),
                displayTime: 5000,
                inTime: 100,
                outTime: 400,
                maxWidth: 700,
                vPosition: "center",
                hPosition: "center",
                className: "toastError signaturePopupRequestFilters",
            });
        };
        ajax.send();
    },
    showAlertMessageError: (result) => {
        if (result.status === 445) {
            const errorMessage = JSON.parse(result.response).errorMessages[0];
            window.globalStore.dispatch({
                type: window.actions.routeSummary.actions.alertMessageModal.OPEN_MODAL_AND_UPDATE_CONTENT,
                payload: {
                    content: errorMessage.resource.value
                }
            });
        }
    },

    addResizableToItemsGrid: () => {
      const itemsElementSelector = "#RouteSummary #lineItemsGrid";
      const itemsElement = document.querySelector(itemsElementSelector);
      const itemsElementHeight = itemsElement.clientHeight;
      const containerParent = document.querySelector("#RouteSummary #contentContainer");
      const containerParentHeight = containerParent.clientHeight;
      const filterHeight = 78;
      const minPercentHeight = 0.5;

      if(itemsElement) {
        const minHeight = itemsElementHeight * minPercentHeight;
        const orderGridElement = document.querySelector("#RouteSummary #ordersGrid");

        const maxHeight =
          containerParentHeight
          - filterHeight
          - (orderGridElement.clientHeight * minPercentHeight);

        const setHeightToElements = (height) => {
          const itemsGrid = App.Forms.RouteSummaryLineItems.table;
          const ordersGrid = App.Forms.RouteSummaryOrders.table;
          const newOrderGridHeight = containerParentHeight - filterHeight - height;

          if(orderGridElement && itemsGrid && ordersGrid) {
            orderGridElement.style.height = `${newOrderGridHeight}px`;
            ordersGrid.resizeCanvas();
            ordersGrid.invalidate();

            itemsGrid.resizeCanvas();
            itemsGrid.invalidate();
          }

        };

        $(itemsElementSelector).resizable({
          handles: "n",
          minHeight,
          maxHeight,
          stop: (_event, ui) => {
            const { height } = ui.size;
            itemsElement.style.top = '';
            setHeightToElements(height);
          }
        });

        const grabDivResizable = document.createElement('div');
        grabDivResizable.className = 'btn-resize';
        grabDivResizable.innerText = '••••••';

        const resizableElement =
          document.querySelector(`${itemsElementSelector} > .ui-resizable-handle`);
          resizableElement.insertAdjacentElement('afterbegin', grabDivResizable);

      }

    },
};
